export type BroPageResponse<T> = {
  count: number;
  results: T[];
};

/**
 * Fetches all pages from a BROstar DRF-paginated endpoint (count / results / page-based).
 *
 * Pass a `fetchPage` function that merges your fixed filter params with the `{ page }`
 * argument it receives:
 *
 * @example
 * fetchAllPages(({ page }) => api.apiGmwMonitoringtubesList({ gmw: uuid, page }))
 */
export const fetchAllPages = async <T>(
  fetchPage: (params: { page: number }) => Promise<BroPageResponse<T>>
): Promise<BroPageResponse<T>> => {
  const first = await fetchPage({ page: 1 });
  const allResults = [...first.results];

  const pageSize = first.results.length;
  if (!pageSize || first.count <= pageSize) return { count: first.count, results: allResults };

  const totalPages = Math.ceil(first.count / pageSize);
  const rest = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, i) => fetchPage({ page: i + 2 }))
  );

  allResults.push(...rest.flatMap(({ results }) => results));
  return { count: first.count, results: allResults };
};
